// Social and external profile links for HamidX
const betterWithKentPlaylistId = ''

const externalLinks = {
	applePodcast: '',
	pocketCasts: '',
	spotify: '',
	simpleCast: '',
	callKentApple: '',
	callKentPocketCasts: '',
	callKentSpotify: '',
	callKentRSS: '',
	betterWithKentYouTube: '',
	betterWithKentPlaylist: '',
	betterWithKentApple: '',
	betterWithKentPocketCasts: '',
	betterWithKentSpotify: '',
	betterWithKentRSS: '',
	discord: '',
	translationContributions: '',
	github: 'https://github.com/hamidxgh',
	githubRepo: 'https://github.com/hamidxgh/hamidxweb',
	youtube: '',
	twitter: 'https://x.com/hamidxtw',
	x: 'https://x.com/hamidxtw',
	linkedin: 'https://www.linkedin.com/in/hamidxli',
	cal: 'https://cal.com/hamidxcal',
	email: 'mailto:contact@hamidxweb.com',
	rss: '/blog/rss.xml',
}

export { betterWithKentPlaylistId, externalLinks }
